import "/vercel/path0/packages/website/sentry.client.config.mjs";
import { init } from 'astro/virtual-modules/prefetch.js';init()